module.exports = __webpack_public_path__ + "img/J13156.563c1c75.png";